<script>
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import satonaybelgesi from "@/models/satonaybelgesi";
import formdate from "@/router/views/formcomponet/formdate.vue";
import forminput from "../formcomponet/forminput.vue";
import formtextarea from "@/router/views/formcomponet/formtextarea.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import onaybelgesi from "./onaybelgesi.vue";
import { ASYNC_SEARCH } from '@riophae/vue-treeselect'
const simulateAsyncOperation = fn => {
  setTimeout(fn, 500)
}


export default {
  props: ["satdosyaId"],
  mixins: [apibtoast, apigeneric, satonaybelgesi],
  page: {
    title: "Onay Belgesi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    forminput,
    formdate,
    formtextarea,
    Treeselect,
    onaybelgesi,
  },
  data() {
    return {
      title: this.$t("satonaybelgesi.Title"),
      FormData: {},

      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      MalzemeVar: {},
      DataUpdate: "",
      AddEdit: "",
      OlcuBirimleri: [],
      excele_aktar: 0,
      pdf_aktar: 0,
      islem: 0,
      guncelle: 0,
      uyesayisikontrol: 0,
      SatDosya: null,
      uri: "data:application/vnd.ms-excel;base64,",
      template: '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      }, 
      
      aktif_arama:false,
    };
  },
  methods: {
     
    loadOptions({ action,  callback }) {
      this.options=[];
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {

           this.options = this.user;

          callback(null, this.options)
        })
      }
    },
   
    
    user_yukle(veri) {
      let Page = {
        PageNumber: "1",
        PageSize: "100",
      };

      if (veri.length >= 1) {
        this.user = [];
        let Filter = "&Adsoyad=" + veri; 

        this.ActionsFilterGet({
          Service: "OPersonel/GetAllPersonel",
          Page: Page,
          Filter: Filter,
        }).then((res) => {
          this.ComboboxUser = res.Data;
          for (var i = 0; i < this.ComboboxUser.length; i++) {
            this.user.push({ id: this.ComboboxUser[i].Id, label: this.ComboboxUser[i].AdSoyad })
          }
        });

      }
    },  
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if(this.MalzemeVar == true){
          if (this.FormData.Id == null || this.FormData.Id == "") {
          this.$delete(this.FormData, "Id");
          this.Post("SatOnayBelgesi", this.FormData)
        } else {
          this.Update("SatOnayBelgesi", this.FormData)
        }
        }else{
          this.$toast.error("Onay Belgesini Kaydedilemedi! Kayıt İçin Malzeme Ekleyiniz");
        }

      }
    },

    gorevli_kontrol() {
      this.uyesayisikontrol = this.FormData.Gorevliler.length % 2;
    },

    Get() {
      this.ActionsFilterGet({ Service: "SatOnayBelgesi", Page: this.Page, Filter: "&Dosyaid=" + this.satdosyaId }).then((res) => {
        if (res.Data.length > 0) {
          this.FormData = res.Data[0];
          this.FormData.Belgetarih = this.$options.filters.formatDate(this.FormData.Belgetarih);
          this.FormDataType.Harcamaid.ComboDataArray = []
          this.FormDataType.Gorevliler.ComboDataArray = []
          this.Page.PageDataSize = res.TotalCount;
        this.ActionsSingleGet({ Service: "SatDosya", Id: this.satdosyaId }).then((res) => {
        this.FormData.Isintanimi = res.Data.Dosyaadi;
        this.FormData.Butcetertibi = res.Data.Hesapkodu;
      });
        
          for(var i=0; i<res.Data[0].Gorevliler.length; i++)
            {  
              this.FormDataType.Gorevliler.ComboDataArray.push ({
                id:res.Data[0].Gorevliler[i],label:res.Data[0].Gorevlileradsoyad[i]
              })
            }
     //     this.FormDataType.Gerceklestimeid.ComboDataArray.push ({id:res.Data[0].Gerceklestimeid,label:res.Data[0].Gerceklestirme})
    //      this.FormDataType.Harcamaid.ComboDataArray.push ({id:res.Data[0].Harcamaid,label:res.Data[0].Harcama})

          
          setTimeout(() => { this.aktif_arama=true;}, 200);
        }
        else{
          this.aktif_arama = true
        }
        this.Page.PageDataSize = res.TotalCount;
        this.ActionsSingleGet({ Service: "SatDosya", Id: this.satdosyaId }).then((res) => {
        this.FormData.Isintanimi = res.Data.Dosyaadi;
        this.FormData.Butcetertibi = res.Data.Hesapkodu;

      });
        this.FormData.Dosyaid = this.satdosyaId;


        this.uyesayisikontrol = this.FormData.Gorevliler.length % 2;

        this.$emit("aktif_menu_title", this.$t("satonaybelgesi.Title"));
      });

      this.ActionsSabitGet(201).then((res) => {
        this.OlcuBirimleri = [];

        for (var i = 0; i < res.Data.length; i++) {
          this.OlcuBirimleri.push({ Id: res.Data[i].Id, Value: res.Data[i].Value });
        }
      });
      this.ActionsSingleGet({ Service: "SatDosya", Id: this.satdosyaId }).then((res) => {
        this.SatDosya = res.Data;
        this.FormData.Gerceklestirme = this.SatDosya.Gerceklestirmegorevlisiid;
        this.ActionsFilterGet({
          Service: "SatDosyaMalzeme",
          Page: this.Page,
          Filter: "&Dosyaid=" + this.SatDosya.Id ,
          }).then((res) => {
            if(res.Data.length > 0){
              this.MalzemeVar = true;
            }
  

          });
      });
      

    },

    /* ExcelExport(table, name) {
      if (!table.nodeType) table = this.$refs.onaybelgesi;
      var ctx = { worksheet: name || "Worksheet", table: table.innerHTML };
      window.location.href =
        this.uri + this.base64(this.format(this.template, ctx));
    },*/
  },
  watch: {
    satdosyaId() {
      this.Get();
    },
  },
  created() {
    this.FormData = this.satonaybelgesiData
  }
};
</script>

<template>
  <Loader>

    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <!--     <div class="col-sm-12">
     
                      <h5>{{$t('satonaybelgesi.Title')}}</h5>

                    </div>  -->

              <div class="col-md-12">
                <Form @submit.prevent="onSubmit">
                  <div class="row">
                    <div class="col-md-4">
                      <formdate :FormDataType="FormDataType.Belgetarih" :Value="FormData.Belgetarih"
                        :v="$v.FormData.Belgetarih" @input="FormData.Belgetarih = $event" />
                    </div>
                    <div class="col-md-4">
                      <forminput :FormDataType="FormDataType.Belgesayi" :Value="FormData.Belgesayi"
                        :v="$v.FormData.Belgesayi" @input="FormData.Belgesayi = $event" />
                    </div>
                    <div class="col-md-4">
                      <forminput :FormDataType="FormDataType.Ilansekliadeti" :Value="FormData.Ilansekliadeti"
                        :v="$v.FormData.Ilansekliadeti" @input="FormData.Ilansekliadeti = $event" />
                    </div>
                  </div>

         <!--        <div class="row">
                    <div class="col-md-12">
                      <forminput :FormDataType="FormDataType.Isintanimi" :Value="FormData.Isintanimi"
                        :v="$v.FormData.Isintanimi" @input="FormData.Isintanimi = $event" />
                    </div>
                  </div> --> 

                  <div class="row">
                    <div class="col-md-6">
                      <forminput :FormDataType="FormDataType.Isinmiktari" :Value="FormData.Isinmiktari"
                        :v="$v.FormData.Isinmiktari" @input="FormData.Isinmiktari = $event" />
                    </div>
                    <div class="col-md-6">
                      <forminput :FormDataType="FormDataType.Teminat" :Value="FormData.Teminat" :v="$v.FormData.Teminat"
                        @input="FormData.Teminat = $event" />
                    </div>

                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <forminput :FormDataType="FormDataType.Yatirimprojenu" :Value="FormData.Yatirimprojenu"
                        :v="$v.FormData.Yatirimprojenu" @input="FormData.Yatirimprojenu = $event" />
                    </div>
               <!--   <div class="col-md-8">
                      <forminput :FormDataType="FormDataType.Butcetertibi" :Value="FormData.Butcetertibi"
                        :v="$v.FormData.Butcetertibi" @input="FormData.Butcetertibi = $event" />
                      <b-form-group v-if="1 == 2" class="mb-3" id="example text" :label="'Bütçe Tertibi'"
                        label-for="text">
                        <treeselect :multiple="false" :options="FormDataType.Butcetertibi.ComboDataArray"
                          placeholder="Seçiniz..." v-model="FormData.Butcetertibi"
                          :class="{ 'is-invalid': $v.FormData.Butcetertibi.$error }" />
                        <treeselect-value :value="FormData.Butcetertibi" />

                        <div v-if="$v.FormData.Butcetertibi.$error" class="invalid-feedback">
                          <span v-if="$v.FormData.Butcetertibi.required == false">{{ $t("ValidationMessage.required")
                          }}</span>
                        </div>
                      </b-form-group>
                    </div>

                    <div class="col-md-6">
                      <forminput :FormDataType="FormDataType.Saymanlik" :Value="FormData.Saymanlik"
                        :v="$v.FormData.Saymanlik" @input="FormData.Saymanlik = $event" />
                    </div>  -->  
                    <div class="col-md-6">
                      <forminput :FormDataType="FormDataType.Avans" :Value="FormData.Avans" :v="$v.FormData.Avans"
                        @input="FormData.Avans = $event" />
                    </div>
                  </div>

                  <div class="row">
                    

                    <div class="col-md-6">
                      <forminput :clas="'text-sm-end'" :FormDataType="FormDataType.Dokumanbedel"
                        :Value="FormData.Dokumanbedel" :v="$v.FormData.Dokumanbedel"
                        @input="FormData.Dokumanbedel = $event" :min="0" :step="0.01" />
                    </div>
                    <div class="col-md-6">
                      <forminput :clas="'text-sm-end'" :FormDataType="FormDataType.Kullanilabilirodenek"
                        :Value="FormData.Kullanilabilirodenek" :v="$v.FormData.Kullanilabilirodenek"
                        @input="FormData.Kullanilabilirodenek = $event" :min="0" :step="0.0001" />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <forminput :FormDataType="FormDataType.Sozlesmevarmi" :Value="FormData.Sozlesmevarmi"
                        :v="$v.FormData.Sozlesmevarmi" @input="FormData.Sozlesmevarmi = $event" />
                    </div>

                    <div class="col-md-6">
                      <forminput :FormDataType="FormDataType.Fiyatfarkivarmi" :Value="FormData.Fiyatfarkivarmi"
                        :v="$v.FormData.Fiyatfarkivarmi" @input="FormData.Fiyatfarkivarmi = $event" />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <formtextarea :FormDataType="FormDataType.Aciklama" :Value="FormData.Aciklama"
                        :v="$v.FormData.Aciklama" @input="FormData.Aciklama = $event" />
                    </div>
                    <div class="col-md-6"> 
                      <b-form-group class="mb-3" id="example text" label="Piyasa Fiyat Araştırma Görevlileri"
                        label-for="text"> 
                        <treeselect :multiple="true" @search-change="user_yukle($event)" :async="aktif_arama"
                          :load-options="loadOptions" :options="FormDataType.Gorevliler.ComboDataArray"
                          placeholder="Seçiniz..." v-model="FormData.Gorevliler"
                          :class="{ 'is-invalid': $v.FormData.Gorevliler.$error }" />
                        <treeselect-value :value="FormData.Gorevliler" />

 

                        <div v-if="$v.FormData.Gorevliler.$error" class="invalid-feedback">
                          <span v-if="$v.FormData.Gorevliler.required == false">{{ $t("ValidationMessage.required")
                          }}</span>
                        </div>
                        <span style="color:red" v-if="uyesayisikontrol == 0">Görevli sayısı uygun değil !</span>
                      </b-form-group>
                    </div>
                  </div>

                  <div class="row">
            <!--       <div class="col-md-6">
                      <b-form-group class="mb-3" id="example text" :label="FormDataType.Gerceklestimeid.FieldTitle"
                        label-for="text"> 
                        <treeselect 
                
               @search-change="user_yukle($event)"
               :async="aktif_arama"
               :load-options="loadOptions"
               :options="FormDataType.Gerceklestimeid.ComboDataArray"
               :multiple="false"   
               :cacheOptions="false"
               searchPromptText="Aramak için yazın..."
               placeholder="Seçiniz..." 
               v-model="FormData.Gerceklestimeid"          
               />
                <treeselect-value :value="FormData.Gerceklestimeid" />

                       

                        <div v-if="$v.FormData.Gerceklestimeid.$error" class="invalid-feedback">
                          <span v-if="$v.FormData.Gerceklestimeid.required == false">{{ $t("ValidationMessage.required")
                          }}</span>
                        </div>
                      </b-form-group>
                    </div> 
                    <div class="col-md-6">
                      <b-form-group class="mb-3" id="example text" :label="FormDataType.Harcamaid.FieldTitle"
                        label-for="text">
                        <treeselect :multiple="false" @search-change="user_yukle($event)" :async="aktif_arama"
                          :load-options="loadOptions" :options="FormDataType.Harcamaid.ComboDataArray"
                          placeholder="Seçiniz..." v-model="FormData.Harcamaid"
                          :class="{ 'is-invalid': $v.FormData.Harcamaid.$error }" />
                        <treeselect-value :value="FormData.Harcamaid" />

                        <div v-if="$v.FormData.Harcamaid.$error" class="invalid-feedback">
                          <span v-if="$v.FormData.Harcamaid.required == false">{{ $t("ValidationMessage.required")
                          }}</span>
                        </div>
                      </b-form-group>
                    </div>-->
                  </div>
                  <hr />
                  <button v-if="!SatDosya.Tamamlandi" class="btn btn-primary" type="submit">
                    {{ $t("satonaybelgesi.Page.Button1") }}
                  </button>
                </Form>
                <button v-if="uyesayisikontrol > 0" class="btn btn-secondary mt-3" v-b-modal.onaybelgesi
                  @click="guncelle = guncelle + 1">
                  <i class="mdi mdi-file-export-outline me-1"></i>
                  Onay Belgesi
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <onaybelgesi :satdosyaId="satdosyaId" v-show="guncelle > 0" :guncelle="guncelle" :excele_aktar="excele_aktar"
      :pdf_aktar="pdf_aktar" />
  </Loader>
</template>
